import { html, LitElement } from 'lit-element';

/**
 * @element response-modal-multiple-choice
 * @prop {Object} response - Response
 */
export class ResponseModalMultipleChoice extends LitElement {
  static get properties() {
    return {
      response: {
        type: Object,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { sessionData, item } = this.response || {};

    const { choices, keyMode } = item || {};
    const { value } = sessionData || {};

    if (!choices || !value) return '';

    const charCode = keyMode === 'numbers' ? 49 : 65;

    const valuesToRender = choices.reduce((acc, choice, index) => {
      if (value.indexOf(choice.value) >= 0) {
        acc.push(index);
      }

      return acc;
    }, []);

    return html`<div class="modal-response-content">
      ${valuesToRender.map(index => {
        const { correct, label } = choices[index] || {};
        const correctnessClass = correct ? 'correct' : 'incorrect';

        return html` <div class="modal-response-content-row">
          <div class="header-correct-response-selection ${correctnessClass}">
            ${String.fromCharCode(index + charCode)}
          </div>
          <div class="response-value">
            <math-rendering-element .label=${label}></math-rendering-element>
          </div>
        </div>`;
      })}
    </div>`;
  }
}

export default ResponseModalMultipleChoice;
